import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AnalyticsPageName } from '@kanalytics';
import { LandingButtonAnalyticsData } from '@kbloc';
import { LandingSection } from '@ktypes/models';

@Component({
  selector: 'kp-landing-section',
  templateUrl: './landing-section.component.html',
  styleUrls: ['./landing-section.component.scss'],
})
export class LandingSectionComponent {
  @Input() section: LandingSection;
  @Input() index: number;
  @Input() hero = false;
  @Input() isLoading = false;
  @Output() getStartedClicked = new EventEmitter<LandingButtonAnalyticsData>();

  analyticsPageName = AnalyticsPageName.landing;

  get isVideo() {
    if (this.section && this.section.media) {
      return (
        this.section.media &&
        (['video/mp4'].indexOf(this.section.media.contentType) > -1 ||
          ['video/quicktime'].indexOf(this.section.media.contentType) > -1)
      );
    }
  }
}
